import { useQuery } from "@tanstack/react-query";

import QueryData from "Constants/QueryData";
import { IPath } from "Types/path";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function usePaths(pageLength?: number) {
  const { status } = useAppSelector((state) => state.menu);
  const { visible } = useAppSelector((state) => state.services);
  const { source, destination } = useAppSelector((state) => state.zones);
  const { conformity, paths } = useAppSelector((state) => state.filters);
  const { center, moveEnd } = useAppSelector((state) => state.map);

  const filterQueries = () => {
    let result = "";
    Object.keys(paths).forEach((i) => {
      const value = paths[i as keyof typeof paths];
      if (i === "q" && value !== "") result += `&${i}=${value}`;
      if (i === "type" && value?.length !== 0) {
        const valLength = value?.length || 0;
        for (let j = 0; j < valLength; j += 1) {
          if (value) result += `&${i}[]=${value[j]}`;
        }
      }
    });
    return result;
  };

  const conformityQuery = () => {
    return `${conformity.source ? "&contain[]=sources" : ""}${conformity.destination ? "&contain[]=destinations" : ""}`;
  };
  const zonesQuery = () => {
    if (source.length === 0 && destination.length === 0) {
      return `&center_lat=${center.lat}&center_lng=${center.lng}&radius=1`;
    }
    return `${source.length > 0 ? `&${source.map((i) => `sources[]=${i}`).join("&")}` : ""}${
      destination.length > 0 ? `&${destination.map((i) => `destinations[]=${i}`).join("&")}` : ""
    }`;
  };
  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: [QueryData.PATH.key, source, destination, conformity, paths],
    queryFn: (): Promise<IPath[]> => {
      return Api.get(`${QueryData.PATH.url}pageLength=20${conformityQuery()}${zonesQuery()}${filterQueries()}`).then(
        (res) => res.data.Data.paths.data
      );
    },
    enabled: visible || status === "paths",
  });

  return { data, isLoading, refetch, isFetching };
}

// &center_lat=21.65467274444767&center_lng=46.71304843709718&radius=1
